module.exports = __webpack_public_path__ + "img/card-image.7e81cedc.png";